const CARD_MODEL_CLASS_NAME = 'Card'

const CARD_MODEL_KEY = {
  ID: 'id',
  BRAND: 'brand',
  LAST4: 'last4'
}

export {
  CARD_MODEL_CLASS_NAME,
  CARD_MODEL_KEY
}
